<ul class="new-breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">Amara Raja</a></li>
    <li class="breadcrumb-item" *ngIf="isAdmin"><a href="javascript:void(0);">Masters</a></li>
    <li class="breadcrumb-item active" aria-current="javascript:void(0);">{{ breadcrumb }} </li>
</ul>
<div class="clearfix"></div>